"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionConfig = exports.currentSectionName = void 0;
// This file was manually generated for this section
const merge_1 = __importDefault(require("lodash/merge"));
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const widgetsNames_1 = require("./widgetsNames");
const helper_1 = require("../../common/helper");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const customHelpers_1 = require("../../common/customHelpers");
exports.currentSectionName = 'visitedPlaces';
const previousSectionName = 'tripsIntro';
const nextSectionName = 'segments';
// Config for the section
exports.sectionConfig = {
    previousSection: previousSectionName,
    nextSection: nextSectionName,
    title: {
        fr: 'Déplacements',
        en: 'Trips'
    },
    widgets: widgetsNames_1.widgetsNames,
    template: 'visitedPlaces',
    onSectionEntry: function (interview, iterationContext) {
        const needUpdateHouseholdSizeValues = (0, customHelpers_1.updateHouseholdSizeFromPersonCount)(interview);
        const person = odSurveyHelper.getPerson({
            interview,
            personId: iterationContext[iterationContext.length - 1]
        });
        // Validate the journey exists
        const journeys = odSurveyHelper.getJourneysArray({ person });
        const journey = journeys[0];
        if (journey === undefined) {
            // This shouldn't happen, but log anyway, just in case
            console.error('No journey found for person:', person._uuid);
            return needUpdateHouseholdSizeValues;
        }
        const updatedValuesByPath = {};
        const visitedPlaces = odSurveyHelper.getVisitedPlacesArray({ journey });
        // Add home as first visited place an add a second one
        if (visitedPlaces.length === 0 && journey.departurePlaceIsHome === 'yes') {
            // Add 2 places: home and the next one
            const newVisitedPlacesValuesByPath = (0, helpers_1.addGroupedObjects)(interview, 2, 1, `household.persons.${person._uuid}.journeys.${journey._uuid}.visitedPlaces`, [
                {
                    activity: 'home',
                    activityCategory: 'home',
                    nextPlaceCategory: 'visitedAnotherPlace'
                },
                {}
            ]);
            Object.assign(updatedValuesByPath, newVisitedPlacesValuesByPath);
            // Select the second place as active place
            for (const path in newVisitedPlacesValuesByPath) {
                if (newVisitedPlacesValuesByPath[path]._sequence === 2) {
                    updatedValuesByPath['response._activeVisitedPlaceId'] = newVisitedPlacesValuesByPath[path]._uuid;
                    break;
                }
            }
        }
        else if (visitedPlaces.length === 0) {
            // Add the first visited place based on the departurePlaceOther
            let firstActivity = null;
            let firstActivityCategory = null;
            if (journey.departurePlaceOther) {
                if (journey.departurePlaceOther === 'otherParentHome') {
                    firstActivity = 'otherParentHome';
                    firstActivityCategory = 'otherParentHome';
                }
                else if (journey.departurePlaceOther === 'restaurant') {
                    firstActivity = 'restaurant';
                    firstActivityCategory = 'shoppingServiceRestaurant';
                }
                else if (journey.departurePlaceOther === 'secondaryHome') {
                    firstActivity = 'secondaryHome';
                    firstActivityCategory = 'leisure';
                }
                else if (journey.departurePlaceOther === 'sleptAtFriends') {
                    firstActivity = 'visiting';
                    firstActivityCategory = 'leisure';
                }
                else if (journey.departurePlaceOther === 'hotelForWork') {
                    firstActivity = 'workNotUsual';
                    firstActivityCategory = 'work';
                }
                else if (journey.departurePlaceOther === 'hotelForVacation') {
                    firstActivity = 'leisureTourism';
                    firstActivityCategory = 'leisure';
                }
                else if (journey.departurePlaceOther === 'studying') {
                    firstActivity = null; // must be specified in the visited places section
                    firstActivityCategory = 'school';
                }
                else if (journey.departurePlaceOther === 'workedOvernight') {
                    firstActivity = null; // must be specified in the visited places section
                    firstActivityCategory = 'work';
                }
            }
            const addValuesByPath = (0, helpers_1.addGroupedObjects)(interview, 1, 1, `household.persons.${person._uuid}.journeys.${journey._uuid}.visitedPlaces`, [
                {
                    activity: firstActivity,
                    activityCategory: firstActivityCategory
                }
            ]);
            Object.assign(updatedValuesByPath, addValuesByPath);
            // Select the new place as active place
            for (const path in addValuesByPath) {
                if (addValuesByPath[path]._sequence === 1) {
                    updatedValuesByPath['response._activeVisitedPlaceId'] = addValuesByPath[path]._uuid;
                    break;
                }
            }
        }
        else {
            // Just select the next visited place ID
            const incompleteVisitedPlace = (0, helper_1.selectNextIncompleteVisitedPlace)({
                interview,
                visitedPlaces,
                person
            });
            updatedValuesByPath['response._activeVisitedPlaceId'] = incompleteVisitedPlace
                ? incompleteVisitedPlace._uuid
                : null;
        }
        return needUpdateHouseholdSizeValues
            ? (0, merge_1.default)(needUpdateHouseholdSizeValues, updatedValuesByPath)
            : updatedValuesByPath;
    },
    enableConditional: function (interview) {
        return (0, helper_1.householdMembersSectionComplete)(interview);
    },
    isSectionCompleted: function (interview, iterationContext) {
        // Section is complete when the last visited place is complete
        const person = odSurveyHelper.getPerson({
            interview,
            personId: iterationContext[iterationContext.length - 1]
        });
        const journey = person ? odSurveyHelper.getJourneysArray({ person })[0] : undefined;
        const visitedPlaces = journey ? odSurveyHelper.getVisitedPlacesArray({ journey }) : [];
        return (visitedPlaces.length > 0 && (0, helper_1.selectNextIncompleteVisitedPlace)({ interview, visitedPlaces, person }) === null);
    },
    isSectionVisible: (interview, iterationContext) => {
        const person = odSurveyHelper.getPerson({
            interview,
            personId: iterationContext[iterationContext.length - 1]
        });
        const journey = person ? odSurveyHelper.getJourneysArray({ person })[0] : undefined;
        // Visible if either the person says has trips or has confirmed she still have trips (the value will be reset later on tripsIntro exit)
        return (journey && (journey.personDidTrips === 'yes' || journey.personDidTripsConfirm === 'yes'));
    }
};
exports.default = exports.sectionConfig;
